import React, { useEffect, useState } from "react";
import { Redirect, useParams, useHistory, Link } from "react-router-dom";
import axios from "axios";
import { storage } from "../../utils";
import { useDashboardRole } from "../../context/dashboardRole";

async function authHeaders() {
  const token = await storage.load("token");
  return { "x-auth": token };
}

const empty = {
  title: "",
  slug: "",
  summary: "",
  body_html: "",
  cover_image: "",
  cover_alt: "",
  seo_description: "",
  category_slug: "",
  author_name: "",
  status: "draft",
};

const MagArticleEdit = () => {
  const { role, loading } = useDashboardRole();
  const { id } = useParams();
  const isNew = !id || id === "new";
  const history = useHistory();
  const [form, setForm] = useState(empty);
  const [cats, setCats] = useState([]);
  const [msg, setMsg] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [uploading, setUploading] = useState(false);

  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  useEffect(() => {
    if (role !== "owner") return;
    (async () => {
      const headers = await authHeaders();
      try {
        await axios.post("/mag/admin/seed_categories", {}, { headers });
      } catch (_) {}
      const c = await axios.get("/mag/admin/categories", { headers });
      setCats(c.data.data || []);
      if (!isNew) {
        const a = await axios.get(`/mag/admin/articles/${id}`, { headers });
        setForm({ ...empty, ...a.data.data });
      }
    })().catch(() => setMsg("خطا در بارگذاری"));
  }, [role, id, isNew]);

  if (!loading && role !== "owner") {
    return <Redirect to="/dashboard/access-denied" />;
  }

  const save = async (nextStatus) => {
    setMsg("");
    try {
      const headers = await authHeaders();
      const body = { ...form, status: nextStatus || form.status };
      let saved;
      if (isNew) {
        const res = await axios.post("/mag/admin/articles", body, { headers });
        saved = res.data.data;
        history.replace(`/dashboard/mag/edit/${saved.id}`);
      } else {
        const res = await axios.patch(`/mag/admin/articles/${id}`, body, {
          headers,
        });
        saved = res.data.data;
        setForm({ ...empty, ...saved });
      }
      setMsg(
        nextStatus === "published"
          ? "منتشر شد."
          : nextStatus === "draft"
          ? "به‌عنوان پیش‌نویس ذخیره شد."
          : "ذخیره شد."
      );
    } catch (e) {
      const m =
        (e.response && e.response.data && e.response.data.message) || "خطا";
      setMsg(m);
    }
  };

  const uploadCover = async (file) => {
    if (!file) return;
    setUploading(true);
    try {
      const headers = await authHeaders();
      const fd = new FormData();
      fd.append("file", file);
      const res = await axios.post("/mag/admin/upload", fd, {
        headers: { ...headers, "Content-Type": "multipart/form-data" },
      });
      setField("cover_image", res.data.data.path);
      setMsg("تصویر بارگذاری شد.");
    } catch (_) {
      setMsg("آپلود ناموفق — فقط تصویر مجاز است.");
    } finally {
      setUploading(false);
    }
  };

  const makePreview = async () => {
    if (isNew) {
      setMsg("ابتدا ذخیره کنید.");
      return;
    }
    try {
      const headers = await authHeaders();
      const res = await axios.post(
        `/mag/admin/articles/${id}/preview_token`,
        {},
        { headers }
      );
      const path = res.data.path;
      setPreviewUrl(`https://pipeup.ir${path}`);
    } catch (_) {
      setMsg("ساخت لینک پیش‌نمایش ناموفق بود.");
    }
  };

  return (
    <div className="content-body" style={{ padding: "1.5rem", maxWidth: 920 }}>
      <h3>{isNew ? "مقاله جدید" : "ویرایش مقاله"}</h3>
      <p className="text-muted">
        HTML در سرور پاک‌سازی می‌شود. تاریخ انتشار اولیه هنگام ویرایش حفظ
        می‌شود.
      </p>
      {msg ? <div className="alert alert-info">{msg}</div> : null}
      <div className="form-group">
        <label>عنوان *</label>
        <input
          className="form-control"
          value={form.title}
          onChange={(e) => setField("title", e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>اسلاگ پایدار</label>
        <input
          className="form-control"
          value={form.slug}
          onChange={(e) => setField("slug", e.target.value)}
          placeholder="خالی = از عنوان"
          dir="ltr"
        />
      </div>
      <div className="form-group">
        <label>خلاصه</label>
        <textarea
          className="form-control"
          rows={3}
          value={form.summary}
          onChange={(e) => setField("summary", e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>متن (HTML امن) *</label>
        <textarea
          className="form-control"
          rows={14}
          value={form.body_html}
          onChange={(e) => setField("body_html", e.target.value)}
          dir="rtl"
        />
      </div>
      <div className="form-row">
        <div className="form-group col-md-6">
          <label>نویسنده واقعی *</label>
          <input
            className="form-control"
            value={form.author_name}
            onChange={(e) => setField("author_name", e.target.value)}
          />
        </div>
        <div className="form-group col-md-6">
          <label>دسته</label>
          <select
            className="form-control"
            value={form.category_slug}
            onChange={(e) => setField("category_slug", e.target.value)}
          >
            <option value="">—</option>
            {cats.map((c) => (
              <option key={c.slug} value={c.slug}>
                {c.name}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="form-group">
        <label>توضیح SEO (اختیاری)</label>
        <input
          className="form-control"
          value={form.seo_description}
          onChange={(e) => setField("seo_description", e.target.value)}
        />
      </div>
      <div className="form-group">
        <label>تصویر کاور</label>
        <input
          type="file"
          accept="image/jpeg,image/png,image/webp,image/gif"
          onChange={(e) => uploadCover(e.target.files && e.target.files[0])}
          disabled={uploading}
        />
        {form.cover_image ? (
          <div className="mt-1">
            <code>{form.cover_image}</code>
          </div>
        ) : null}
      </div>
      <div className="form-group">
        <label>متن جایگزین تصویر</label>
        <input
          className="form-control"
          value={form.cover_alt}
          onChange={(e) => setField("cover_alt", e.target.value)}
        />
      </div>
      <div className="d-flex flex-wrap" style={{ gap: 8 }}>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => save("draft")}
        >
          ذخیره پیش‌نویس
        </button>
        <button
          type="button"
          className="btn btn-success"
          onClick={() => save("published")}
        >
          انتشار
        </button>
        {!isNew && form.status === "published" ? (
          <button
            type="button"
            className="btn btn-warning"
            onClick={() => save("draft")}
          >
            لغو انتشار
          </button>
        ) : null}
        <button type="button" className="btn btn-outline-primary" onClick={makePreview}>
          لینک پیش‌نمایش خصوصی
        </button>
        <Link className="btn btn-light" to="/dashboard/mag">
          بازگشت
        </Link>
      </div>
      {previewUrl ? (
        <p className="mt-2">
          پیش‌نمایش (noindex):{" "}
          <a href={previewUrl} target="_blank" rel="noopener noreferrer">
            {previewUrl}
          </a>
        </p>
      ) : null}
    </div>
  );
};

export { MagArticleEdit };
